export const reviewDetail = [
  {
    review_id: 0,
    label: "Review Date",
    value: "review_date",
  },
  {
    review_id: 1,
    label: "Review Interval (months)",
    value: "review_interval",
  },
  {
    review_id: 2,
    label: "Review Completed",
    value: "review_completed",
  },
  {
    review_id: 3,
    label: "Review Note",
    value: "review_reason",
  },
  {
    review_id: 4,
    label: "Review Date",
    value: "review_assigned",
  },
];
export const providerDetail = [
  {
    providerDetail_id: 0,
    label: "Provider Name",
    value: "provider_name",
  },
  {
    providerDetail_id: 1,
    label: "Group",
    value: "group_name",
  },
  {
    providerDetail_id: 2,
    label: "Contact",
    value: "contact_name",
  },
  {
    providerDetail_id: 3,
    label: "Address",
    value: "address1",
  },
  {
    providerDetail_id: 4,
    label: "Town",
    value: "town",
  },
  {
    providerDetail_id: 5,
    label: "County",
    value: "county",
  },
  {
    providerDetail_id: 6,
    label: "Country",
    value: "country",
  },
  {
    providerDetail_id: 7,
    label: "Postcode",
    value: "postcode",
  },
  {
    providerDetail_id: 8,
    label: "Salutation",
    value: "salutation",
  },
  {
    providerDetail_id: 9,
    label: "Telephone",
    value: "telephone",
  },
  {
    providerDetail_id: 10,
    label: "Fax",
    value: "fax",
  },
  {
    providerDetail_id: 11,
    label: "Mobile",
    value: "mobile",
  },
  {
    providerDetail_id: 12,
    label: "Email",
    value: "email",
  },
  {
    providerDetail_id: 13,
    label: "Status",
    value: "status",
  },
  {
    providerDetail_id: 14,
    label: "Note",
    value: "note_text",
  },
];
